import React, {Fragment} from 'react';
import {useDispatch, useSelector} from "react-redux";
import {faCheckDouble} from "@fortawesome/free-solid-svg-icons";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import logo from '../assets/img/logo.svg';

const FinalizacionProceso = (props) => {
    const mensaje = useSelector(state => state.parametrosBusqueda.mensaje);
 
    return (
        <Fragment>
            <div className="alert alert-secondary mt-30 p-30 t-center" role="alert">
                <img src={logo} alt="" height="49px"/>
                <hr />
                <h6><FontAwesomeIcon className="feature-box__icon feature-box__icon--small"
                                        icon={faCheckDouble}/> {mensaje} 
                </h6>
                <button 
                    className="btn btn-lg btn-chapur btn-block" 
                    onClick={() => {
                        props.firstStep();
                    }}
                >
                    Regresar
                </button>
            </div>
        </Fragment>);
};

export default FinalizacionProceso;